'use client';

import {
    ComponentPropsWithoutRef,
    createContext,
    Dispatch,
    SetStateAction,
    useContext,
    useEffect,
    useState,
} from 'react';
import { cn } from '@/shared/lib/cn';
import { Layout } from '@/shared/ui/layout';
import './product-detail.scss';
import { ProductDetailContext } from './provider';

type ProductDetailGalleryContextValue = {
    selectedIndex: number;
    setSelectedIndex: Dispatch<SetStateAction<number>>;
};

export const ProductDetailGalleryContext = createContext<ProductDetailGalleryContextValue>(
    {} as ProductDetailGalleryContextValue,
);

type Props = ComponentPropsWithoutRef<'div'>;

export const ProductDetailGalleryWrapper = ({ children, className, ...props }: Props) => {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const { currentItem } = useContext(ProductDetailContext);

    useEffect(() => {
        setSelectedIndex(0);
    }, [currentItem?.id]);

    if (!currentItem?.assets?.length) {
        return null;
    }

    return (
        <ProductDetailGalleryContext.Provider value={{ selectedIndex, setSelectedIndex }}>
            <Layout className={cn('product-detail__gallery-wrapper', className)} {...props}>
                {children}
            </Layout>
        </ProductDetailGalleryContext.Provider>
    );
};

export const useProductDetailGallery = () => {
    return useContext(ProductDetailGalleryContext);
};
